import questionRoute from './containers/Question/routes'
import resultRoute from './containers/Result/routes'
import AccountPersonalTasteProfile from './containers/AccountPersonalTasteProfile'
import TasteProfileOnboarding from './index'
import sagas from './sagas'
import sliceReducer from './sliceReducer'
import Start from './components/Start'
import createListener from 'utils/createListener'
import storageAvailable from 'utils/storageAvailable'
import { TASTE_PROFILE_WINE_LIST_URL } from 'constants/global'
import WineList from './containers/WineList'

export default ({store, injectReducer, injectSagas}) => {
  // inject saga's only when this route is added
  injectSagas(sagas)

  // cache questions & answered state in localStorage
  if (storageAvailable('localStorage')) {
    store.subscribe(
      createListener(
        store,
        (state) => state.tasteProfileOnboarding,
        (state) => {
          localStorage.setItem('data-version', JSON.stringify(process.env.LOCALSTORAGE_DATA_VERSION))
          localStorage.setItem('tasteProfileOnboardingState', JSON.stringify(state))
        }
      )
    )
  }

  return [
    {
      path: TASTE_PROFILE_WINE_LIST_URL,
      component: WineList,
      onEnter: () => {
        injectReducer('tasteProfileOnboarding', sliceReducer)
      }
    },
    {
      path: process.env.WEBSHOP_SMAAKPROFIELEN_PATH + '/doe-de-test',

      indexRoute: {
        component: Start
      },

      childRoutes: [
        ...questionRoute,
        ...resultRoute(injectSagas)
      ],

      component: TasteProfileOnboarding,

      onEnter: ({params}, replace) => {
        injectReducer('tasteProfileOnboarding', sliceReducer)

        // If initial request is a question URL, then redirect to start
        if (params.question) {
          replace(process.env.WEBSHOP_SMAAKPROFIELEN_PATH + '/doe-de-test/')
        }
      }
    },
    {
      path: '/accounts/smaakprofiel/',
      component: AccountPersonalTasteProfile,

      onEnter: () => {
        injectReducer('tasteProfileOnboarding', sliceReducer)
      }
    }]
}
